import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Api, Code } from '@.api';
import { IForm } from '@.hooks';
import { Layout } from '@.layout';
import { ParentCompanyForm } from '@/Components/Partials/ParentCompany';
import { LinkHelper } from '@/Services';
import { ParentCompanyCreateType } from '@/Types/ParentCompany';

export const ParentCompanyCreatePage = () => {
    const navigate = useNavigate();

    const save = async (data: ParentCompanyCreateType, form: IForm<ParentCompanyCreateType>) => {
        const parentCompanyApi = Api.parentCompany();

        const response = await parentCompanyApi.create(data);

        if (response.code === Code.ValidationError) {
            form.set.errors(response.errors);
            return;
        }

        if (response.code === Code.Success) {
            navigate(LinkHelper.parentCompanies.all);
        }

        throw response;
    };

    return (
        <Layout name="Parent company" small breadcrumbs={[{ name: 'Parent Company' }, { name: 'Create' }]}>
            <h1>Create parent company</h1>
            <ParentCompanyForm onSave={save} />
        </Layout>
    );
};
